import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// init store
const store = new Vuex.Store({
  state: {
    user: {
      authenticated: false,
      token: null,
      expiration: null,
    },
    // toggle variables, every time they are changing
    flags: {
      reloadNav: false,
      showHelpGuide: true,
      showVisitorHelpGuide: true,
    },
  },
  mutations: {
    setUserAuthStatus(state, status) {
      state.user.authenticated = status
    },
    setUserAuthToken(state, token) {
      state.user.token = token
    },
    setUserAuthExpiration(state, expiration) {
      state.user.expiration = expiration
    },
    logout(state) {
      state.user.authenticated = false
      state.user.token = null
    },
    toggleFlag(state, flagVar) {
      state.flags[flagVar] = !state.flags[flagVar]
    },
  },
  getters: {
    isLoggedIn: state => {
      const tokenNotExpired = new Date(state.user.expiration) > new Date()
      return state.user.authenticated && tokenNotExpired
    },
    token: state => {
      return state.user.token
    },
    showHelpGuide: state => {
      return state.flags.showHelpGuide
    },
    showVisitorHelpGuide: state => {
      return state.flags.showVisitorHelpGuide
    },
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
    }),
  ],
})

export default store
